export enum ConstructionTypesBuild {
  GREEN_RESOURCE = 'green_resource',
  RESOURCE = 'resource',
  ACTION = 'action',
  PART_ACTION = 'part_action',
  INSTITUTION = 'institution',
  DANGER = 'danger',
}
